/**
 * File: AslFibController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class AslFibController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, $timeout,CONSTANTS,CQuesConst,uploadService,randomColorService) {
        
    var MQ = MathQuill.getInterface(2);
    let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
    let userId = localStorageService.get("user_id")
    let USER_PATH = userId + "/asl/"
    let schoolId = localStorageService.get("school_id")
    let ASL_ANS_TYPE=CQuesConst.ASL_ANS_TYPE
    let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
    let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT
    let GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES
    let GET_PASSAGE = CQuesConst.API_GET_PASSAGE
    let SAVE_URL = CQuesConst.API_CREATE_DRAW
    $scope.errors = {};

    $scope.index;

    $scope.fib = {}

    $scope.fib.answers = [];

        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Archives"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            $scope.index = this.index
            $scope.id = "answer" + $scope.index
            if ($scope.$parent.editQuestions[$scope.index]) {
                $scope.questionData = $scope.$parent.editQuestions[$scope.index]
                if ($scope.questionData) {
                    $scope.fib.qn_desc = $scope.questionData.qn_desc;
                    $scope.fib.questionImg = $scope.questionData.questionImg;
                }
            }
        }
        //On destroy function
        this.$onDestroy = () => {
        }
        
        $timeout(function() {
            if ($scope.questionData && $scope.questionData.answer) {
                $scope.fib.onQuesLoad()
                $scope.fib.answers = _.map($scope.questionData.answer, function(ans) {
                    ans["color"] = randomColorService.getRandomColor()
                    return ans;
                })
            }
        }, 1000);

        $scope.fib.onQuesLoad = function() {
            if ($scope.fib.qn_desc === undefined) {
                return
            }
            let question = $scope.fib.qn_desc;
            let fibOptions = question.split('_')
            let loadedQst = ""
            let querySl = "#" + $scope.id
            let myEl = angular.element(document.querySelector(querySl));
            myEl.empty();
            $scope.fib.answers = []
            _.each(fibOptions, function(option, index) {
                if (index === (fibOptions.length - 1)) {
                    loadedQst = " " + option.trim()
                    myEl.append(loadedQst)
                    return
                }
                if ($scope.questionData && $scope.questionData.answer && $scope.questionData.answer[index]) {
                    $scope.fib.answers.push({
                        "color": randomColorService.getRandomColor(),
                        "desc": $scope.questionData.answer[index].desc,
                        "explanation": $scope.questionData.answer[index].explanation
                    })
                } else {
                    $scope.fib.answers.push({
                        "color": randomColorService.getRandomColor()
                    })
                }
                loadedQst = " " + option.trim() + " "
                myEl.append(loadedQst)
                myEl.append($compile('<md-input-container class="fibAnswer"><label>Enter Answer</label><textarea md-maxlength="50" txt-maxlength="50" type="text" ng-model="fib.answers[' + index + '].desc"></textarea><p class="errorMessage">{{errors["answers.' + index + '.desc"]}}</p></md-input-container>')($scope))
            })
        }

        //Image upload for Question
        $scope.fib.uploadImg = function(file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function(fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                    // if (fileObj.type === "image/jpg" || fileObj.type === "image/jpeg" || fileObj.type === "image/png") {
                        uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                        if (result.url) {
                            opt.questionImg = result.url
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }

        $scope.fib.removeImage = function() {
            $scope.fib.questionImg = undefined;
        }

        /*
         * Function to add to list
         *
         * @return : null
         */
        $scope.addToList = () => {
            $scope.errors = {}
            let errCount = 0;
            let answerArr = []
            _.each($scope.fib.answers, function(ans, index) {
                let ansObj = {
                    "desc": ans.desc,
                    "explanation": ans.explanation
                }
                answerArr.push(ansObj)
            })
            let obj = {
                qn_desc: $scope.fib.qn_desc,
                answer: answerArr
            }
            if (obj.qn_desc == null || obj.qn_desc == undefined || obj.qn_desc == "") {
                $scope.errors.qn_desc = "Question is required";
                errCount++;
            } else if (obj.qn_desc.split('_').length < 2) {
                $scope.errors.qn_desc = "Enter a valid question";
                errCount++;
            }
            if (obj.answer) {
                _.each(obj.answer, function(answer, index) {
                    if (answer.desc == null || answer.desc == undefined || answer.desc == "") {
                        $scope.errors["answers." + index + ".desc"] = "Answer is required"
                        errCount++;
                    }
                })
            }
            if (errCount == 0) {
                let objtoAdd = {
                    type: ASL_ANS_TYPE.FIB,
                    qn_desc: $scope.fib.qn_desc,
                    answer: answerArr,
                    questionImg:$scope.fib.questionImg
                }
                $scope.fib.qn_desc = ''
                $scope.fib.questionImg = ''
                _.each($scope.fib.answers, function(option_val, option_key) {
                    $scope.fib.answers[option_key].explanation = ''
                })
                $scope.$parent.addToList(objtoAdd, $scope.index)
            }
        }

    }
}

export default AslFibController;


// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/aslFibController.js